import { createFileRoute, Outlet } from "@tanstack/react-router";
import { LayoutDashboard, UserCog, HeartPulse, IndianRupee, Camera, BarChart3, Megaphone, Wallet } from "lucide-react";
import { DashboardShell, type NavItem } from "@/project/components/dashboard-shell";

const items: NavItem[] = [
  { to: "/institution", label: "Dashboard", icon: LayoutDashboard },
  { to: "/institution/profile", label: "Profile", icon: UserCog },
  { to: "/institution/campaigns", label: "Campaigns", icon: Megaphone },
  { to: "/institution/causes", label: "Causes", icon: HeartPulse },
  { to: "/institution/donations", label: "Donations", icon: IndianRupee },
  { to: "/institution/impact", label: "Impact Updates", icon: Camera },
  { to: "/institution/payouts", label: "Settlements", icon: Wallet },
  { to: "/institution/reports", label: "Reports", icon: BarChart3 },
];

export const Route = createFileRoute("/institution")({
  head: () => ({ meta: [{ title: "Institution Dashboard — Animal Seva" }]}),
  component: () => (
    <DashboardShell role="Institution Admin" orgName="Shree Ahmedabad Panjrapole" color="var(--maroon)" items={items}>
      <Outlet />
    </DashboardShell>
  ),
});